/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';
import type { TextMessageStepPriority } from './textMessageStepPriority';
import type { TextMessageStepSmsBodyDoc } from './textMessageStepSmsBodyDoc';
import type { TextMessageStepTaskNoteDoc } from './textMessageStepTaskNoteDoc';

export interface TextMessageStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: TextMessageStepPriority;
  type: 'text_message';
  sms_body_doc?: TextMessageStepSmsBodyDoc;
  task_note_doc?: TextMessageStepTaskNoteDoc;
}
